var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCaution(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "_x32_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#000000;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M437.014,74.978C390.77,28.697,326.608-0.014,256,0C185.393-0.014,121.222,28.697,74.977,74.978 C28.696,121.223-0.015,185.393,0,256c-0.015,70.608,28.696,134.778,74.977,181.023C121.222,483.304,185.393,512.015,256,512 c70.608,0.015,134.77-28.696,181.014-74.977c46.289-46.245,75-110.415,74.986-181.023 C512.014,185.393,483.304,121.223,437.014,74.978z M399.474,112.526c36.763,36.8,59.414,87.355,59.43,143.474 c-0.015,56.119-22.667,106.674-59.43,143.474c-36.807,36.763-87.363,59.415-143.474,59.429 c-56.119-0.014-106.674-22.666-143.474-59.429C75.762,362.674,53.111,312.119,53.096,256 c0.014-56.118,22.666-106.674,59.429-143.474c36.8-36.763,87.356-59.415,143.474-59.43 C312.111,53.112,362.667,75.763,399.474,112.526z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M256,332.408c-15.97,0-29.052,13.089-29.052,29.052c0,15.963,13.082,29.044,29.052,29.044 c15.962,0,29.051-13.082,29.051-29.044C285.051,345.497,271.962,332.408,256,332.408z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M256,311.986c6.533,0,15.704-28.86,18.059-37.296c7.326-24.43,13.348-57.726,13.348-85.259 c0-32.866-9.17-67.934-31.407-67.934c-22.252,0-31.415,35.067-31.415,67.934c0,27.534,6.03,60.83,13.355,85.259 C240.296,283.126,249.452,311.986,256,311.986z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaution);
export default __webpack_public_path__ + "static/media/caution.3c6b9d84455fdf318c48d8ac67f63028.svg";
export { ForwardRef as ReactComponent };